import React, { Component } from 'react';
import { graphql } from 'react-relay';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { Link, withRouter } from 'react-router-dom';
import classNames from 'classnames';

import LanguageDropdown from './LanguageDropdown';
import { LanguageConsumer } from '../context/LanguageContext';
import NavigationMenuMobile from './NavigationMenuMobile';
import { UserConsumer } from '../context/UserContext';
import QueryHandler from '../misc/QueryHandler';

import { trackEvent } from '../../utils/ga-tracking';

////////////////////////////////////////////
// TODO MISSING TESTS
////////////////////////////////////////////

class SportografNavigationBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mobileExpanded: false,
      mobileAccountExpanded: false,
      mobileLanguageExpanded: false,
    };
  }

  handleMobileExpand = () => {
    if (this.state.mobileExpanded) {
      document.body.style.overflow = 'initial';
    } else {
      document.body.style.overflow = 'hidden';
    }

    this.setState({
      mobileExpanded: !this.state.mobileExpanded,
      mobileAccountExpanded: false,
      mobileLanguageExpanded: false,
    });
  };

  hideMobileMenu = () => {
    this.setState({
      mobileExpanded: false,
      mobileAccountExpanded: false,
      mobileLanguageExpanded: false,
    });

    document.body.style.overflow = 'initial';
  };

  handleMobileAccountDropdown = () => {
    if (this.state.mobileExpanded) {
      this.setState({
        mobileAccountExpanded: !this.state.mobileAccountExpanded,
      });
    }
  };

  handleMobileLanguageDropdown = () => {
    if (this.state.mobileExpanded) {
      this.setState({
        mobileLanguageExpanded: !this.state.mobileLanguageExpanded,
      });
    }
  };

  render() {
    const { intl, location, match } = this.props;

    const { mobileExpanded, mobileLanguageExpanded, mobileAccountExpanded } = this.state;
    const transparentNavigation = location.pathname === `/${match.params.language}` || location.pathname === `/${match.params.language}/about`;

    return (
      <LanguageConsumer>
        {({ language, onLanguageChange }) => (
          <UserConsumer>
            {({ isLoggedIn, onLoginChange }) => (
              <div
                className={classNames('navigation-bar-container-outer', {
                  'navigation-bar-transparent': transparentNavigation,
                })}
              >
                <section
                  className={classNames(
                    'navigation-bar-container',
                    'container-full-width',
                    'container-960',
                    {
                      'mobile-expanded': mobileExpanded,
                    }
                  )}
                >
                  <Link className="navigation-bar-logo" to="/">
                    <img src="/images/sg-logo-new-no-text.png" />
                    <span>SPORTOGRAF</span>
                  </Link>
                  <div className="navigation-bar-items-container">
                    <div onClick={this.hideMobileMenu} className="navigation-bar-item">
                      <QueryHandler
                        hasLoadingIndicator={false}
                        query={graphql`
                          query SportografNavigationBarQuery {
                            viewer {
                              cart {
                                lineItems {
                                  id
                                }
                              }
                            }
                          }
                        `}
                        render={props => {
                          const { cart } = props.viewer;
                          if (cart) {
                            return (
                              <Link
                                className="navigation-bar-checkout"
                                to="/cart"
                                onClick={() =>
                                  trackEvent('Navigation', 'Checkout', 'Cart icon')
                                }
                              >
                                <span data-count={cart.lineItems.length} />
                              </Link>
                            );
                          }
                          return null;
                        }}
                        shouldHandleError={false}
                      />
                    </div>
                    <div className="navigation-bar-items">
                      <div
                        className="navigation-bar-item"
                        onClick={this.hideMobileMenu}
                      >
                        <Link className="navigation-bar-home" to="/:language">
                          {intl.formatMessage(translations.homeItem)}
                        </Link>
                      </div>
                      {!isLoggedIn && (
                        <div
                          className="navigation-bar-item"
                          onClick={this.hideMobileMenu}
                        >
                          <Link className="navigation-bar-login" to="/login">
                            {intl.formatMessage(translations.loginItem)}
                          </Link>
                        </div>
                      )}
                      {isLoggedIn && (
                        <div
                          className={classNames(
                            'navigation-bar-item',
                            'navigation-bar-account',
                            {
                              'dropdown-expanded': mobileAccountExpanded,
                            }
                          )}
                        >
                          <div
                            className="navigation-bar-dropdown-main"
                            onClick={this.handleMobileAccountDropdown}
                          >
                            {intl.formatMessage(translations.accountItem)}
                          </div>
                          <div className="navigation-bar-dropdown">
                            <div
                              className="navigation-bar-dropdown-item"
                              onClick={this.hideMobileMenu}
                            >
                              <Link to="/account/events">
                                {intl.formatMessage(translations.myEventsItem)}
                              </Link>
                            </div>
                            <div
                              className="navigation-bar-dropdown-item"
                              onClick={this.hideMobileMenu}
                            >
                              <Link to="/account/orders">
                                {intl.formatMessage(translations.myOrdersItem)}
                              </Link>
                            </div>
                            <div
                              className="navigation-bar-dropdown-item"
                              onClick={() => {
                                onLoginChange(false);
                                this.hideMobileMenu();
                              }}
                            >
                              <Link to="/">
                                {intl.formatMessage(translations.logoutItem)}
                              </Link>
                            </div>
                          </div>
                        </div>
                      )}
                      <div
                        className="navigation-bar-item"
                        onClick={this.hideMobileMenu}
                      >
                        <Link className="navigation-bar-about" to="/about">
                          {intl.formatMessage(translations.aboutItem)}
                        </Link>
                      </div>
                      <LanguageDropdown
                        language={language}
                        onLanguageChange={onLanguageChange}
                        handleMobileLanguageDropdown={this.handleMobileLanguageDropdown}
                        mobileLanguageExpanded={mobileLanguageExpanded}
                        hideMobileMenu={this.hideMobileMenu}
                      />
                    </div>
                  </div>
                  <NavigationMenuMobile handleMobileExpand={this.handleMobileExpand} />
                </section>
              </div>
            )}
          </UserConsumer>
        )}
      </LanguageConsumer>
    );
  }
}

SportografNavigationBar.propTypes = {
  viewer: PropTypes.object,
  intl: PropTypes.object,
  match: PropTypes.object,
  location: PropTypes.object,
};

const translations = defineMessages({
  cartItem: {
    id: 'navigationBar.cartItem',
    defaultMessage: '({count})',
  },
  homeItem: {
    id: 'navigationBar.homeItem',
    defaultMessage: 'Home',
  },
  accountItem: {
    id: 'navigationBar.accountItem',
    defaultMessage: 'My Account',
  },
  aboutItem: {
    id: 'navigationBar.aboutItem',
    defaultMessage: 'About Us'
  },
  loginItem: {
    id: 'navigationBar.account.loginItem',
    defaultMessage: 'Login',
  },
  logoutItem: {
    id: 'navigationBar.account.logoutItem',
    defaultMessage: 'Logout',
  },
  myEventsItem: {
    id: 'navigationBar.account.myEventsItem',
    defaultMessage: 'My photos',
  },
  myOrdersItem: {
    id: 'navigationBar.account.myOrdersItem',
    defaultMessage: 'My invoices',
  },
});

export default injectIntl(withRouter(SportografNavigationBar));
